import { Suspense } from 'react';
import { ThemeProvider, defaultTheme } from '@zeptonow/zui/theme';
import AppLayout from './layout';
import CircularProgress from '@zeptonow/zui/CircularProgress';
import { TableContextProvider } from '@zeptonow/zui';

const App = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Suspense
        fallback={
          <CircularProgress
            isOpen
            className="mt-5 !relative !text-purple-800"
          />
        }
      >
        <TableContextProvider>
          <AppLayout />
        </TableContextProvider>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
